/** API. */
export enum Api {
  /** Square 9, GlobalSearch. */
  square9,
  /** Viewer. */
  viewer,
  /** GlobalSearch Extensions. */
  gse,
}
